import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";

import { RightContainerStyled } from "../../assets/styles/theme";
import OriginalGrid from "./shared/OriginalDataGrid";

import SnackbarComponent from "./shared/SnackBarComponent";
import SnackbarSuccessComponent from "./shared/SnackBarSuccessComponent";

import {
  useGetClientsConfigurations,
  useUpdateDataSourcesStatus,
} from "../hooks";

import {
  CLIENTS_CONFIG_SCREEN_LABEL,
  CLIENTS_CONFIG_TABLE_PLACEHOLDER,
  CLIENTS_CONFIG_TABLE_STORAGE_KEY,
  ClientsConfigDataColumns,
  ClientsConfigSampleData,
} from "../helpers/constants";
import CredentialConfigComponents from "./CredentialConfigComponents";
import DeleteFile from "./modals/DeleteFile";
import styled from "styled-components";

interface ClientsConfigurationsComponentProps {}

const ClientPlatfromsTableWrapper = styled.div`
    .MuiTableRow-root {
      cursor: pointer;
    }
  `;

const ClientsConfigurationsComponent: React.FC<
  ClientsConfigurationsComponentProps
> = ({}) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const {
    data: getClientsConfigurationsData,
    isLoading: isGetClientsConfigurationsDataPending,
    error: getClientsConfigurationsError,
  } = useGetClientsConfigurations();

  const {
    mutate: updateDataSourcesStatus,
    isPending: isUpdateDataSourcesStatusPending,
  } = useUpdateDataSourcesStatus();

  const [error, setError] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  const [success, setSuccess] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState("");

  const [deleteDialog, setDeleteDialog] = React.useState(false);
  const [selectedPlatform, setSelectedPlatform] = React.useState<any>(null);

  const [handleDeleteModal, setHandleDeleteModal] = React.useState(false);

  const redirectManagePlatform = (item: any) => {
    console.log("item redirectManagePlatform", item);
    const stateObj = {
      id: item?.clientId,
      prevScreen: "clients-platforms",
      clientHasDataSourceId: item?.clientHasDataSourceId,
    };
    navigate("/manage-platforms", { state: stateObj });
  };

  const handleDelete = (item: any, type: any) => {
    console.log("type", type, item);
    if (type == "PlatformStatus") {
      setDeleteDialog(true);
      setSelectedPlatform(item);
    }
  };

  const handleConfirmDelete = () => {
    console.log("deleteDialog", deleteDialog);
    const body = {
      id: selectedPlatform.clientHasDataSourceId,
      reqBody: { status: !selectedPlatform.status },
    };
    console.log("body", body);
    updateDataSourcesStatus(body, {
      onSuccess: onUpdateDataSourcesStatusSuccess,
      onError: onUpdateDataSourcesStatusError,
    });
  };

  const onUpdateDataSourcesStatusSuccess = (res: any) => {
    let status = selectedPlatform.status ? "In Active" : "Active";
    const successMessage = `This platform has been changed to ${status}`;
    setDeleteDialog(false);
    setSelectedPlatform(null);
    setSuccess(true);
    setSuccessMessage(successMessage);
    queryClient.invalidateQueries({ queryKey: ["dataSource-clients"] });
  };

  const onUpdateDataSourcesStatusError = (err: any) => {
    setDeleteDialog(false);
    setSelectedPlatform(null);
    setError(true);
    setErrorMessage(err?.data?.message);
    setHandleDeleteModal(false);
  };

  const handleDeleteFileCancel = () => {
    setDeleteDialog(false);
    setSelectedPlatform(null);
  };

  const hideError = () => {
    setError(false);
    setErrorMessage("");
  };

  const hideSuccess = () => {
    setSuccess(false);
    setSuccessMessage("");
  };

  

  return (
    <>
      {/* <CredentialConfigComponents /> */}
      <RightContainerStyled>
        <ClientPlatfromsTableWrapper>
          <Typography variant="h1" component="h1" className="">
            {CLIENTS_CONFIG_SCREEN_LABEL}
          </Typography>
          <Box>
            <OriginalGrid
              showUnassignedToggle={false}
              data={getClientsConfigurationsData?.data}
              columns={ClientsConfigDataColumns}
              onRowClick={(item) => redirectManagePlatform(item)}
              isGroupingEnabled={false}
              isExportEnabled={true}
              defaultSortColumn="createdDate"
              defaultSortDirection="desc"
              rowsPerPageOptions={[10, 20, 50, 100]}
              storageKey={CLIENTS_CONFIG_TABLE_STORAGE_KEY}
              loading={isGetClientsConfigurationsDataPending}
              showFileUploadModal={false}
              placeholder={CLIENTS_CONFIG_TABLE_PLACEHOLDER}
              isFixedColumn={false}
              exportFileName={"ClientPlatforms"}
              isFixedRightColumn={false}
              handelAction={handleDelete}
              isEditMode={false}
              editData={{}}
              handleFilePopUpClose={() => console.log("del")}
              handleAttachmentsDownload={() =>
                console.log("handleAttachmentsDownload")
              }
              fromScreen="Client-Config"
              industryOptions={[]}
              handleSaveFormSubmission={() =>
                console.log("handleSaveFormSubmission")
              }
              uploadType={null}
            />
          </Box>

          {deleteDialog && (
            <DeleteFile
              open={deleteDialog}
              handleCancel={handleDeleteFileCancel}
              handleConfirm={handleConfirmDelete}
              subject={"PlatformStatus"}
              status={selectedPlatform.status ? false : true}
              fileName={"this Data Source"}
              isLoading={isUpdateDataSourcesStatusPending}
            />
          )}
          {error && (
            <SnackbarComponent
              error={error}
              errorMessage={errorMessage}
              hideError={hideError}
            />
          )}
          {success && (
            <SnackbarSuccessComponent
              success={success}
              successMessage={successMessage}
              hideSuccess={hideSuccess}
            />
          )}
        </ClientPlatfromsTableWrapper>
      </RightContainerStyled>
    </>
  );
};

export default ClientsConfigurationsComponent;
